import React from "react";

/** Outline dog-bone glyph for Treats amounts (angled). */
export default function TreatIcon({ className = "treatIcon", title = "Treats" }) {
    return (
        <svg
            className={className}
            viewBox="0 0 24 24"
            width="1em"
            height="1em"
            aria-hidden={title ? undefined : true}
            role={title ? "img" : "presentation"}
            focusable="false"
        >
            {title ? <title>{title}</title> : null}
            <path
                fill="none"
                stroke="currentColor"
                strokeWidth="1.7"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7.15 8.35a2.35 2.35 0 1 0-2.35 2.35 2.35 2.35 0 1 0 2.35 2.35h9.7a2.35 2.35 0 1 0 2.35-2.35 2.35 2.35 0 1 0-2.35-2.35H7.15z"
            />
        </svg>
    );
}
